var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ '': !_vm.isDarkMode, 'bg-dark': _vm.isDarkMode },attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }